import { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;
  requiredRole?: 'patient' | 'practitioner' | 'admin' | 'moderator';
  requireVerified?: boolean;
}

export function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const { user, roles, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;

    if (!user) {
      navigate('/auth');
      return;
    }

    if (requiredRole && !roles.includes(requiredRole)) {
      navigate('/home');
      return;
    }
  }, [user, roles, loading, requiredRole, navigate]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-dvh">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) return null;
  if (requiredRole && !roles.includes(requiredRole)) return null;

  return <>{children}</>;
}

export default ProtectedRoute;
